const { onlyAlphaNumeric, SPACE } = require('../helpers');

const states = {
  'Brunei-Muara': 'Brunei-Muara',
  Belait: 'Belait',
  Tutong: 'Tutong',
  Temburong: 'Temburong'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);

  return zip.slice(0, 7);
};

exports.countryDefinition = {
  country: 'Brunei Darussalam',
  code: 'BN',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'City' },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'District',
      width: 0.5
    },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city', SPACE, 'stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['zipCode', 'stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[BKTP]{1}[A-Z]{1}[0-9]{4}$/),
      error: 'Must be 2 characters+4 numbers, BT2328'
    }
  ]
};
